import { useState } from 'react';

export function useColumnVisibility(pageKey, defaultCols) {
  const storageKey = `colVis_${pageKey}`;
  const [visible, setVisible] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey));
      return saved || defaultCols;
    } catch { return defaultCols; }
  });
  const toggle = (col) => {
    const updated = visible.includes(col) ? visible.filter(c => c !== col) : [...visible, col];
    setVisible(updated);
    localStorage.setItem(storageKey, JSON.stringify(updated));
  };
  return { visible, toggle };
}
